import { createReducer, on } from '@ngrx/store';

import { setPreferenceIndicesCalcs } from './family-indices-table.action';

export const preferenceIndicesCalcs = createReducer(
    [] as string[],
    on(setPreferenceIndicesCalcs, (state: string[], action) => {
        return action.calcs;
    })
);
